import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../environments/environment';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-account-activation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    HttpClientModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    SharedModule
  ],
  templateUrl: './account-activation-dialog.component.html'
})
export class AccountActivationDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private dialogRef: MatDialogRef<AccountActivationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { verificationCode: string }
  ) {
    this.form = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [
        Validators.required,
        Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*/]).{8,}$/)
      ]],
      confirmPassword: ['', Validators.required],
    }, { validators: this.passwordsMatch });
  }

  ngOnInit(): void {
    this.http.get<any>(`${environment.api.BASE_URL}/auth/activation-info?code=${this.data.verificationCode}`).subscribe({
      next: userInfo => {
        console.log(">> USER INFO :", userInfo);
        
        this.form.patchValue({
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
          email: userInfo.email
        });
      },
      error: () => {
        alert("Code invalide ou expiré.");
        this.dialogRef.close();
      }
    });
  }

  passwordsMatch(group: FormGroup) {
    const pass = group.get('password')?.value;
    const confirm = group.get('confirmPassword')?.value;
    return pass === confirm ? null : { notMatching: true };
  }

  get passwordFormField(): string {
    return this.form.get('password')?.value || '';
  }

  submit() {
    if (this.form.valid) {
      const payload = {
        ...this.form.value,
        code: this.data.verificationCode
      };
      console.log(">> PAYLOAD :", payload);
      this.http.patch(`${environment.api.BASE_URL}/auth/account/activate`, payload , { responseType: 'text' }).subscribe({
        next: () => {
          alert("Compte activé avec succès !");
          //this.dialogRef.close();
          window.location.href = "https://collary-team.vercel.app/login";
        },
        error: err => {
          alert("Erreur lors de l'activation.");
          console.error(err);
        }
      });
    }
  }
}
